import { DappCard } from 'components/Card';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Dapps = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-3 md:grid-cols-6 gap-x-2 md:gap-x-4 gap-y-4 text-center text-eth-primary dark:text-eth-light">
      <DappCard
        title={t('dapps.whirlpool.title')}
        imgSrc={'/img/dapps/whirlpool.png'}
        dappUrl={'https://eth.surf.finance/whirlpool'}
        infoUrl={'https://docs.surf.finance/core-dapps/the-whirlpool'}
      ></DappCard>
      <DappCard
        title={t('dapps.the_beach.title')}
        imgSrc={'/img/dapps/beach.png'}
        dappUrl={'https://polygon.surf.finance/the-beach'}
        infoUrl={'https://docs.surf.finance/core-dapps/the-beach'}
      ></DappCard>
      <DappCard
        title={t('dapps.surf3d.title')}
        imgSrc={'/img/dapps/surf3d.png'}
        dappUrl={'https://3d.surf.finance/'}
        infoUrl={'https://docs.surf.finance/core-dapps/surf3d'}
      ></DappCard>
      <DappCard
        title={t('dapps.rsurf.title')}
        imgSrc={'/img/dapps/rsurf.png'}
        dappUrl={
          'https://ipfs.io/ipfs/QmcgFohpduxebiDiTuPCihBy4yHtwocJbLCrpm18vKQQg1/dashboard.html'
        }
        infoUrl={'https://docs.surf.finance/core-dapps/rsurf'}
      ></DappCard>
      <DappCard
        title={t('dapps.polywave.title')}
        imgSrc={'/img/dapps/polywave.png'}
        dappUrl={'https://polywave.finance'}
        infoUrl={'https://docs.surf.finance/core-dapps/polywave'}
      ></DappCard>

      <DappCard
        title={t('dapps.tide_rider.title')}
        imgSrc={'/img/dapps/tiderider.png'}
        dappUrl={'https://arcade.surf.finance/'}
        infoUrl={
          'https://docs.surf.finance/ancillary-and-partner-dapps/tide-rider-the-legend-of-surf'
        }
      ></DappCard>
    </div>
  );
};

export default Dapps;
